'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '@eliadmin/core/src/components/ui/button';

export function Hero({ slides }: { slides: TDynamicData[] }) {
  return (
    <section className="w-full">
      <Swiper
        pagination={true}
        navigation={true}
        autoplay={{
          delay: 5000,
        }}
        loop={true}
        modules={[A11y, Navigation, Pagination, Autoplay]}
        slidesPerView={1}
        className={cn(
          'mySwiper',
          'h-[500px] w-full md:h-[700px]',
          'ea-hero__swiper',
          'custom-container flex items-center justify-center',
        )}
      >
        {slides.map((slide, index) => {
          const Title = index === 0 ? 'h1' : 'h2';
          return (
            <SwiperSlide
              key={slide.name}
              className="relative flex w-full items-center justify-center"
            >
              <div className="absolute left-1/2 top-1/2 z-10 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-4 text-start">
                <Title
                  className={cn(
                    'relative',
                    'w-full px-6 text-center text-5xl font-medium text-white sm:text-6xl lg:text-7xl',
                  )}
                >
                  {slide.name}
                </Title>
                <span
                  className={cn(
                    'font-heading',
                    'px-6 text-center text-4xl text-white sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl',
                  )}
                >
                  {slide.fields[0]?.value}
                </span>
                {slide.fields[1]?.value && (
                  <Button asChild>
                    <Link prefetch={false} href={slide.fields[2]?.value}>
                      {slide.fields[1]?.value}
                    </Link>
                  </Button>
                )}
              </div>
              <div className="absolute inset-0 z-[1] h-full w-full bg-black/20" />
              <Image
                src={slide?.image?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(slide?.image, slide?.name)}
                fill
                priority={index === 0}
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchPriority={index === 0 ? 'high' : 'low'}
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="100vw"
                className="absolute inset-0 z-0 h-full w-full"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}
